import { render, staticRenderFns } from "./PosN_Checkout.vue?vue&type=template&id=540f5ce0"
import script from "./PosN_Checkout.vue?vue&type=script&lang=js"
export * from "./PosN_Checkout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports